// extracted by mini-css-extract-plugin
export default {"container":"FormWithTitleWrap_container__JlwaO","header":"FormWithTitleWrap_header__Bmdqx","flicker":"FormWithTitleWrap_flicker__z49JU","title":"FormWithTitleWrap_title__Flbux"};